export const DEFAULT_SCALE_START = 1;
export const DEFAULT_SCALE_END = 5;

export const DEFAULT_SCALE_COUNT = DEFAULT_SCALE_END - DEFAULT_SCALE_START + 1;